import Customers from '@/pages/customerAdmin/CustomerAdmin.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/customers')({
  // component: () => <IFramePage url="customer-crud.html" />,
  component: () => <CustomersLayout />,
})

const CustomersLayout = () => {
  return (
    <>
      <Customers />
      <Outlet />
    </>
  )
}
